
export function getTowerVersion() {
  return document.querySelector('meta[name="tower-version"]').getAttribute('content');
}

export function checkTowerVersion(version) {
  const currentVersion = getTowerVersion();
  if (currentVersion && currentVersion !== version) {
    window.location.reload(true);
  }
}

export function setOuterHTML(element, value) {
  element.insertAdjacentHTML('afterend', value);
  // eslint-disable-next-line no-param-reassign
  element.outerHTML = '';
}

export function getInputValue(query) {
  const dom = document.querySelector(query);
  if (dom) return dom.value;
  return null;
}

export function camelCase(str) {
  return str.replace(/^([A-Z])|[\s-_]+(\w)/g, (_, p1, p2) => {
    if (p2) return p2.toUpperCase();
    return p1.toLowerCase();
  });
}

export function throttle(callback, wait) {
  let timer = null;
  let previous = 0;
  let result = null;

  return (...args) => {
    const now = Date.now();
    const remaining = wait - (now - previous);

    if (remaining <= 0 || remaining > wait) {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }

      previous = now;
      result = callback(...args);
    } else if (!timer) {
      timer = setTimeout(() => {
        previous = Date.now();
        timer = null;
        result = callback(...args);
      }, remaining);
    }

    return result;
  };
}

export function DOMEval(code) {
  const script = document.createElement('script');
  script.text = code;
  document.head.appendChild(script).parentNode.removeChild(script);
}
